export default {
  events: [
    { value: 'create', description: 'Criar' },
    { value: 'update', description: 'Atualizar' },
    { value: 'destroy', description: 'Remover' }
  ],
  registers: [
    { value: 'Contract', description: 'Contrato' },
    { value: 'Invoice', description: 'Parcela' },
    { value: 'PaymentMethod', description: 'Método de Pagamento' },
    { value: 'Plan', description: 'Plano' },
    { value: 'Service', description: 'Serviço' },
    { value: 'User', description: 'Usuário' },
    { value: 'Member', description: 'Dependente ' }
  ],
  who: [
    { value: 'admin', description: 'Administrador' },
    { value: 'user', description: 'Usuário' }
  ]
};
